import type { IUser } from '@carboncopyco/types';
import { Spacer, TextBase } from '@carboncopyco/ui';
import type React from 'react';

interface ActivityItemUpdateTitleProps {
  onClick?: () => void;
  title: string;
  externalText?: string | React.ReactNode;
  text: string | React.ReactNode;
  creator?: IUser | Record<string, never>;
}

export const ActivityItemUpdateTitle = ({
  onClick,
  title,
  externalText,
  text,
  creator = {},
}: ActivityItemUpdateTitleProps) => {
  return (
    <div
      className="flex flex-col cursor-pointer"
      onClick={onClick}
    >
      <div>
        {creator && (
          <TextBase
            label={`${creator.name ?? ''}`}
            color={
              creator?.isDeleted ? 'text-ds-natural-200' : 'text-ds-primary'
            }
          />
        )}
        <Spacer
          amount={0.25}
          inline
        />
        {typeof text === 'string' ? (
          <TextBase
            label={text}
            color="text-ds-natural-600"
          />
        ) : (
          text
        )}
        <Spacer
          amount={0.25}
          inline
        />
        <TextBase
          label={title}
          color="text-ds-primary"
        />
        <Spacer
          amount={0.25}
          inline
        />
        {typeof externalText === 'string' ? (
          <TextBase
            label={externalText}
            color="text-ds-natural-600"
          />
        ) : (
          externalText
        )}
      </div>
    </div>
  );
};
